// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xhG9","col":"styles_col__2r7Z8"};